// extracted by mini-css-extract-plugin
export default {"pdf-list":"UnionTimes_pdf-list__YwRsW","pdf-item":"UnionTimes_pdf-item__5YOCP","pdf-icon":"UnionTimes_pdf-icon__-mZxL","pdf-link":"UnionTimes_pdf-link__phgSR"};